
import React from "react";
import ProgramDetailsSection from "../../../../components/template/ProgramDetailSection";

const InnerEdge = () => {
  return (
    <ProgramDetailsSection
      title="INNER-EDGE"
      tagline="Personal Effectiveness Workshop"
      highlights={[
        "Science-backed learning",
        "Practical workplace application",
        "Sustainable behavioural change",
      ]}
      description="INNER-EDGE is a transformational personal effectiveness workshop designed to help individuals unlock their highest potential through greater focus, resilience, productivity, and high-performance habits. Participants gain practical tools that enhance performance while maintaining balance and wellbeing."
      duration="1.5 Days"
      focusAreas={[
        "Focus & Attention Mastery",
        "Productivity & Performance",
        "Growth Mindset",
        "Emotional Resilience",
        "High-Performance Habits",
      ]}
      outcomes={[
        "Improve focus, productivity, and effectiveness without burnout.",
        "Develop greater resilience and adaptability under pressure.",
        "Learn how to consistently perform at your best while maintaining wellbeing.",
      ]}
      images={[
        "../../../cw/CW2.JPG",
        "../../../cw/CW3.JPG",
        "../../../cw/CW4.JPG"

        
      ]}
    />
  );
};

export default InnerEdge;
